import { Component, Input, ViewChild, inject } from "@angular/core";
import { UserDetailModel } from "@app/user/user-maintenance/shared/user-detail-model";
import { UserMaintenanceService } from "@app/user/user-maintenance/services/user-maintenance.service";
import { HistoryOverviewComponent } from "@app/shared/history-overview/history-overview.component";

@Component({
    selector: "user-history",
    templateUrl: "./user-history.component.html",
    styleUrls: ["./user-history.component.scss"],
    standalone: false
})
export class UserHistoryComponent {
    _historyDS = inject(UserMaintenanceService);

    @Input() user: UserDetailModel;
    @ViewChild("historyComponent") historyComponent: HistoryOverviewComponent;

    loaded = false;

    load() {
        if (!this.loaded) {
            this.historyComponent.loadHistory();
            this.loaded = true;
        }
    }
}
